import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

const PrivateRoute = ({ children }) => {
  const token = Cookies.get("auth-token");

  if (!token) {
    return <Navigate to="/" />; // Redirect to login if no token
  }

  return children; // Render children if authenticated
};

export default PrivateRoute;
